import { useEffect, useState, useRef } from "react";
import { api } from "../../services/api";
import { useTranslation } from "react-i18next";
import { routesURL } from "../../services/routesUrl";

interface Country {
  code: string;
  name: string;
}

export function useCountries() {
  const { t } = useTranslation();

  const TRANSLATE_DEFAULT_COUNTRIES: Country[] = [
    { code: "US", name: t("unitedStates") },
    { code: "AU", name: t("australia") },
    { code: "NZ", name: t("newZealand") },
  ];

  const [countries, setCountries] = useState<Country[]>(
    TRANSLATE_DEFAULT_COUNTRIES,
  );
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const hasShownError = useRef(false);

  async function fetchCountries() {
    setIsLoading(true);
    setError(null);

    try {
      const response = await api.get<Country[]>(
        routesURL.auth.supportedCountries,
      );

      setCountries(response.data);
      hasShownError.current = false;
    } catch (err: any) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    fetchCountries();
  }, []);

  return {
    countries,
    isLoading,
    error,
  };
}
